"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilHelper = void 0;
class UtilHelper {
    static preventDefaultAndStopPropagation(event) {
        if (event) {
            if (typeof event.preventDefault === 'function') {
                event.preventDefault();
            }
            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }
        }
    }
}
exports.UtilHelper = UtilHelper;
